<template>
  <div class="mi-swiper-wrapper-wraper">
    <div ref="swiper" class='mi-swiper' :class="className">
      <div ref="wrapper" class="mi-swiper-wrapper">
        <slot></slot>
      </div>
      <div v-if="pagination" class="mi-swiper-pagination">
        <div 
          v-for="(i, id) in total"
          :key="i + '_' + id"
          class="pagination-item" 
          :class="{'active': id == index}" track-by="id"
          @click="clickPagination(id)"
          >
            {{id - 0 + 1}}
          </div>
      </div>
      
    </div>
    <div v-if="preNextBtn" class="mi-swiper-btn">
      <div  class="pre-btn" @click.prevent="movePre"><</div>
      <div class="next-btn" @click.prevent="moveNext">></div> 
    </div>
</div>
</template>
<script>
  export default {
    name: "mi-swiper",
    props: {
      autoplay: {
        type: Boolean,
        default: true,
      },
      preNextBtn: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: Number,
        default: 300,
      },
      interval: {
        type: Number,
        default: 5000,
      },
      pagination: {
        type: Boolean,
        default: true,
      }

    },
    data() {
      return {
        className: '',
        index: 0,
        boxWidth: 0,
        total: 0,
      };
    },
    methods: {
      resetDom() {
        this.total = this.$children.length;
        this.$nextTick(() => {
          var wrapper = this.$refs.wrapper;
          if(wrapper){
            var slides = wrapper.getElementsByClassName('mi-swiper-slide');
            this.boxWidth = wrapper.offsetWidth;
            if(this.total > 1) {
              let cloneDom1 = slides[0].cloneNode(true);
              wrapper.appendChild(cloneDom1);
            }
            if(this.autoplay) {
              this._setTime();
            }
          }
        })
      },
      _setTime() {
        if(this._timer) {
          clearTimeout(this._timer);
          this._timer = null;
        }
        this._timer = window.setTimeout(() => {
          if(this.autoplay) {
            this.index++;
            this.move();
          }
        }, this.interval);
      },
      _setTranslate(num) {
        this.$refs.wrapper.style.transform = 'translateX(' + num + 'px)';
      },
      move() {
        var wrapper = this.$refs.wrapper;
        if(!wrapper) return;
        wrapper.style.transition = this.duration + 'ms';
        this._setTranslate(-1 * this.index * this.boxWidth);
        if(this.autoplay) {
          this._setTime();
        }
        setTimeout(() => {
          wrapper.style.transition = '0ms';
          if(this.index >= this.total) {
            this.index = 0;
            this._setTranslate(0);
          }
        }, this.duration);
      },
      clickPagination(index) {
        this.index = index;
        this.move();
        this._setTime();
      },
      movePre() { 
        if (this.index == 0) { 
          return;
        }
        this.index--;

        this.move();
        this._setTime()
      },
      moveNext() { 
        console.log(this.index, this.total)
        if ((this.index+1) >= this.total) { 
          return;
        }
        this.index++;
        this.move();
        this._setTime()
      }
    },
    mounted() {
      this.className = 'mi-swiper__' + Math.random().toFixed(5) * 100000;
      this.resetDom();
    },
    beforeDestroy() {
      if(this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
    },
  };
</script>
<style lang="scss">
  .mi-swiper{
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;
    &-wrapper{
      display: flex;
    }
    &-pagination{
      position: absolute;
      width: 100%;
      left: 0;bottom: 10px;
      font-size: 0px;
      text-align: center;
      .pagination-item{
        user-select: none;
        width: 20px;
        height: 14px;
        line-height: 14px;
        cursor: pointer;
        display: inline-block;
        color: #666;
        font-size: 14px;
        &.active{
          color: #ff6701;
          opacity: 1;
        }
      }
    }
   
  }
  .mi-swiper-wrapper-wraper{
    position: relative;
     .mi-swiper-btn{
      cursor: pointer;
      
      .pre-btn{
        position: absolute;
        color:#fff;
        z-index: 99999;
        text-align: center;
        line-height: 98px;
        font-size: 20px;
        font-weight: bold;
        left: -200px;
        top: 300px;
        width: 66px;
        height: 98px;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.8);

      }
      .next-btn{
        position: absolute;
        color:#fff;
        text-align: center;
        line-height: 98px;
        font-size: 20px;
        font-weight: bold;
        right: -200px;
        top: 300px;
        width: 66px;
        height: 98px;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.8);

      }

      
    }
  }
</style>
